export const singleAssetNotIncludedText = `Sorry! There is an Asset that can't be included in the request list.
It's possible that asset is already present in either the request list or an alternate outgoing request.`;

export const allAssetsNotIncludedText = `Assets can't be included in the request list.
It's possible that assets is already present in either the request list or an alternate outgoing request.`;

export const getSomeAssetsNotIncludedText = (assetCount: number) => (
	`Sorry! There are ${assetCount} Assets that can't be included in the request list.
	It's possible that assets is already present in either the request list or an alternate outgoing request.`
);
